export const BLOG_CATEGORIES = [
  { value: 'health', label: 'Health' },
  { value: 'technology', label: 'Technology' },
  { value: 'nutrition', label: 'Nutrition' },
  { value: 'tips', label: 'Tips' },
] as const;

export const BLOG_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'default' },
  { value: 'published', label: 'Published', color: 'success' },
  { value: 'scheduled', label: 'Scheduled', color: 'processing' },
  { value: 'archived', label: 'Archived', color: 'warning' },
] as const;

export type BlogCategory = (typeof BLOG_CATEGORIES)[number]['value'];
export type BlogStatus = (typeof BLOG_STATUSES)[number]['value'];

export const getBlogCategoryLabel = (category: string): string =>
  BLOG_CATEGORIES.find((item) => item.value === category)?.label ?? category;

export const getBlogStatusMeta = (status: string) =>
  BLOG_STATUSES.find((item) => item.value === status) ?? {
    value: status,
    label: status,
    color: 'default',
  };
